import {MapStates, USER_LIST_ROLES} from '@q9elements/ui-kit/common';

import {MapUsers} from './map';

export const mapUsersList: MapUsers[] = [
  {title: 'MAP.MANAGERS', role: 'manage', totalCount: 0, users: [], type: 'map'},
  {title: 'MAP.EDITORS', role: 'edit', totalCount: 0, users: [], type: 'map'},
  {title: 'MAP.NAMED_VIEWERS', role: 'view', totalCount: 0, users: [], type: 'map'},
  {title: 'USER.SPACE_VIEWERS', role: 'spaceView', totalCount: 0, users: [], type: 'space'}
];

export const userRoleOptions = [
  {
    title: 'USER.PERMISSIONS_VIEW_ONLY',
    value: USER_LIST_ROLES.VIEW,
    q9Track: 'USER.PERMISSIONS_VIEW_ONLY'
  },
  {
    title: 'USER.PERMISSIONS_CAN_EDIT',
    value: USER_LIST_ROLES.EDIT,
    q9Track: 'USER.PERMISSIONS_CAN_EDIT'
  },
  {
    title: 'USER.PERMISSIONS_MANAGE',
    value: USER_LIST_ROLES.MANAGE,
    q9Track: 'USER.PERMISSIONS_MANAGE'
  }
];

export enum RemoveUserErrorStatus {
  Training = 'user.err.undergoing_training',
  Authorization = 'user.err.undergoing_authorisation'
}

export const notReadyMapStates = [MapStates.COPYING, MapStates.IMPORTING];

export const upnDefaultThemeName = 'UPN Default Theme';

/**
 * Credit requirements for AI-powered map generation features
 */
export const AI_GENERATION_CREDIT_COSTS = {
  /** Credits required for text/image to UPN diagram generation */
  GENERATE_MAP: 1000,
  /** Credits required for Salesforce org to data model generation */
  ORG_TO_MODEL: 5000,
  /** Credits required for Salesforce org to process diagram generation */
  ORG_TO_PROCESS: 5000
} as const;
